export default function About() {
  return (
    <section id="about" className="flex min-h-screen">
      {/* Left Panel - Visual */}
      <div className="w-1/2 bg-[#F8F9FA] flex items-center justify-center p-20">
        <div className="relative w-full h-[80vh]">
          <div className="absolute top-8 left-8 text-xs uppercase tracking-[3px] text-gray-600 font-medium">
            / About Us
          </div>
          <div className="w-full h-full rounded-[20px] overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)]">
            <img 
              src="https://public.readdy.ai/ai/img_res/e46960d02723e0b63344a045d1fe80ce.jpg" 
              alt="iOS Development Team" 
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>

      {/* Right Panel - Content */}
      <div className="w-1/2 bg-white flex items-center px-20">
        <div className="max-w-[480px]">
          <h3 className="text-[56px] font-bold text-[#1A1A1A] mb-10 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Expert Team
          </h3>
          <p className="text-base text-[#4A4A4A] leading-[1.8] mb-8">
            <strong>LILA SH.P.K.</strong> is a team of experts developing modern applications for the iOS platform. Our products, such as <strong>VPN</strong> and <strong>Cleaner</strong>, are designed to enhance user experience and improve the security of mobile devices.
          </p>
          <p className="text-base text-[#4A4A4A] leading-[1.8]">
            With years of experience in <strong>iOS development</strong> and <strong>mobile security</strong>, our dedicated team focuses on creating innovative solutions that protect user privacy and optimize device performance. We combine cutting-edge technology with user-centric design to deliver applications that meet the highest standards of quality and reliability.
          </p>
        </div>
      </div>
    </section>
  );
}